import { useToastStore } from "stores/toastStore";
import { ModelList } from "types/Common";

export const getReactQueryNextPageNum = (
  lastPage: ModelList<any>,
  pageSize: number,
): number | undefined => {
  if (!lastPage.page) {
    // 페이지 정보가 없음
    return undefined;
  }

  const { totalCount, page } = lastPage;
  const totalPage = Math.ceil(totalCount / pageSize); // 총 페이지 수

  return totalPage > page ? page + 1 : undefined;
};

// 토스트 메세지
export const toast = (message: string, delay?: number) => {
  useToastStore.getState().showToast(message, delay);
};
